import React from 'react'
import { Link } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { fetchSchoolInformation } from '../../lib/supabase'

export function DatenschutzContent({ showHeading = true } = {}) {
  const [schoolName, setSchoolName] = useState('Ihrer Schule')

  useEffect(() => {
    let active = true
    ;(async () => {
      try {
        const info = await fetchSchoolInformation()
        if (active) setSchoolName((info && info.name) ? String(info.name) : 'Ihrer Schule')
      } catch {
        if (active) setSchoolName('Ihrer Schule')
      }
    })()
    return () => { active = false }
  }, [])

  return (
    <div className="max-w-3xl w-full bg-white shadow rounded-lg p-6 space-y-4">
      {showHeading && <h1 className="text-2xl font-semibold">Datenschutzerklärung</h1>}
      <p className="text-sm text-gray-600">Datenschutzerklärung für FlexWise</p>

      <section className="space-y-2 text-sm text-gray-800">
        <h2 className="font-semibold">1. Verantwortlichkeit</h2>
        <p>Die FlexWise-Plattform wird von der {schoolName} genutzt. Verantwortlich im Sinne der DSGVO ist die jeweilige Schule, die entscheidet, welche Daten erhoben, verarbeitet und genutzt werden. FlexWise stellt die technische Infrastruktur bereit und agiert dabei als Auftragsverarbeiter nach Art. 28 DSGVO.</p>
      </section>

      <section className="space-y-2 text-sm text-gray-800">
        <h2 className="font-semibold">2. Welche Daten wir verarbeiten</h2>
        <ul className="list-disc pl-5 space-y-1">
          <li>Stammdaten: Name, Vorname, Geburtsdatum, Klassen- und Gruppenzugehörigkeit, Kontaktdaten.</li>
          <li>Familien- und Betreuungsinformationen: Angaben zu Sorgeberechtigten, Abholregelungen, Kommunikationswege.</li>
          <li>Schul- und Kursorganisation: Stundenpläne, Kursbelegungen, Anwesenheits- und Fehlzeiten.</li>
          <li>Gesundheits- und besondere Hinweise (Art. 9 DSGVO): Allergien, chronische Erkrankungen, Notfallhinweise, ärztliche Atteste, Foto- oder Veröffentlichungserlaubnisse.</li>
          <li>Kommunikationsdaten: Mitteilungen zwischen Schule und Eltern, interne Aushänge, organisatorische Informationen.</li>
          <li>Technische Daten: Logfiles, Nutzungsprotokolle, Zeitpunkt von Änderungen, Geräteinformationen.</li>
        </ul>
        <p>Welche dieser Daten konkret genutzt werden, bestimmt allein die Schule. FlexWise selbst greift auf diese Inhalte nicht zu.</p>
      </section>

      <section className="space-y-2 text-sm text-gray-800">
        <h2 className="font-semibold">3. Rechtsgrundlagen der Verarbeitung</h2>
        <ul className="list-disc pl-5 space-y-1">
          <li>Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung)</li>
          <li>Art. 6 Abs. 1 lit. c DSGVO (rechtliche Verpflichtungen)</li>
          <li>Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse, z. B. IT-Sicherheit)</li>
          <li>Art. 6 Abs. 1 lit. a DSGVO (Einwilligung)</li>
          <li>Art. 9 Abs. 2 lit. a DSGVO (Einwilligung) bzw. lit. g/h DSGVO (öffentliches Interesse/Gesundheitsvorsorge)</li>
        </ul>
      </section>

      <section className="space-y-2 text-sm text-gray-800">
        <h2 className="font-semibold">4. Zwecke der Verarbeitung</h2>
        <ul className="list-disc pl-5 space-y-1">
          <li>Kurs- und Stundenplanung</li>
          <li>Anwesenheits- und Abwesenheitserfassung</li>
          <li>Krankmeldungen und Abholregelungen</li>
          <li>Schulische Kommunikation und Aushänge</li>
          <li>Erfüllung rechtlicher Dokumentationspflichten</li>
          <li>IT-Sicherheit und Missbrauchsvermeidung</li>
          <li>Verarbeitung von Excel-Dateien im Rahmen interner Funktionen</li>
        </ul>
      </section>

      <section className="space-y-2 text-sm text-gray-800">
        <h2 className="font-semibold">5. Speicherdauer</h2>
        <ul className="list-disc pl-5 space-y-1">
          <li>Organisatorische Daten: mit Ende des Schuljahres/Schulverhältnisses, sofern keine Pflichten entgegenstehen</li>
          <li>Gesundheits-/Abholinformationen: unmittelbar nach Wegfall des Zwecks</li>
          <li>Logfiles: in der Regel nach 7 Tagen</li>
        </ul>
      </section>

      <section className="space-y-2 text-sm text-gray-800">
        <h2 className="font-semibold">6. Empfänger der Daten</h2>
        <ul className="list-disc pl-5 space-y-1">
          <li>Berechtigte Personen innerhalb der Schule</li>
          <li>Externe Dienstleister auf Basis von AVV (Art. 28 DSGVO)</li>
          <li>Keine Drittstaatenübermittlung außer für Auth/Sicherheit: Twilio (SMS 2FA), Google/Apple (OAuth/2FA) über SCC (Art. 46 DSGVO) + TOM</li>
          <li>Hosting ausschließlich in Deutschland (z. B. Hetzner, IONOS)</li>
          <li>Mobile App über Stores (Google/Apple) – deren Datenschutzhinweise gelten zusätzlich</li>
        </ul>
      </section>

      <section className="space-y-2 text-sm text-gray-800">
        <h2 className="font-semibold">7. Sicherheit der Verarbeitung</h2>
        <ul className="list-disc pl-5 space-y-1">
          <li>SSL/TLS, rollenbasiertes Zugriffssystem</li>
          <li>Protokollierung, Backups, europäische Server</li>
          <li>Firewalls und 2FA für Administratoren</li>
        </ul>
      </section>

      <section className="space-y-2 text-sm text-gray-800">
        <h2 className="font-semibold">8. Rolle von FlexWise</h2>
        <p>FlexWise verarbeitet Daten ausschließlich im Auftrag der Schulen und entscheidet nicht über Zwecke/Mittel der Verarbeitung.</p>
      </section>

      <section className="space-y-2 text-sm text-gray-800">
        <h2 className="font-semibold">9. Rechte der Betroffenen</h2>
        <ul className="list-disc pl-5 space-y-1">
          <li>Auskunft, Berichtigung, Löschung, Einschränkung</li>
          <li>Datenübertragbarkeit, Widerruf, Beschwerde bei der Aufsichtsbehörde</li>
        </ul>
      </section>

      <section className="space-y-2 text-sm text-gray-800">
        <h2 className="font-semibold">10. Ansprechpartner</h2>
        <p>Primärer Ansprechpartner ist die Schule als Verantwortliche. Zusätzlich: FlexWise UG Datenschutzbeauftragter erreichbar unter <a href="mailto:dsb@flexwise.info" className="text-blue-600 underline">dsb@flexwise.info</a>.</p>
      </section>

      <div className="pt-2 hidden sm:block">
        <Link to="/" className="text-blue-600 hover:underline">Zurück</Link>
      </div>
    </div>
  )
}

export default function Datenschutz() {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-6">
      <DatenschutzContent />
    </div>
  )
}
